import React, { useRef, useState } from "react";
import styles from "./schoolRitual.module.css";
import { Box, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BlockSeven from "../../components/blockSeven/blockSeven";
import LazySection from "../../components/LazySection";
import Image from "next/image";
import SchoolRitualBlockThree from "../../components/schoolRitualBlockThree/schoolRitualBlockThree";
import Block2 from "../../components/blockTwo/block2";
import SchoolRitualBlockFour from "../../components/schoolRitualBlockFour/schoolRitualBlockFour";
import SchoolRitualBlockSix from "../../components/schoolRitualBlockSix/schoolRitualBlockSix";
import BlockFive from "../../components/blockFive/blockFive";
import Head from "next/head";
import Link from "next/link";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);
  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);
  const ritualPraxisRef = useRef(null);
  const theResonateNatureRef = useRef(null);
  const theTheurgicRitualRef = useRef(null);
  const theFiveStandardPentaSet = useRef(null);
  const banishingInvocationRitual = useRef(null);
  const divineInfiniteInvocationRitual = useRef(null);
  const planetaryInvocationRitual = useRef(null);
  const zodiacalInvocationRitual = useRef(null);
  const celestialInvocationRitual = useRef(null);
  const grandTheurgicInvocation = useRef(null);
  const introGrandTheurgicInvocation = useRef(null);
  const theMacrocosmicRef = useRef(null);
  const theMicrocosmicRef = useRef(null);
  const aligningTheElementsRef = useRef(null);
  const invocationOfDivineInfiniteBeing = useRef(null);
  const natalIncarnationRef = useRef(null);
  const planetaryResonanceRef = useRef(null);
  const planetaryDecagramRef = useRef(null);
  const ariesInvocationRef = useRef(null);
  const taurasInvocationRef = useRef(null);
  const geminiInvocationRef = useRef(null);
  const cancerInvocationRef = useRef(null);
  const leoInvocationRef = useRef(null);
  const virgoInvocationRef = useRef(null);
  const libraInvocationRef = useRef(null);
  const scorpioInvocationRef = useRef(null);
  const sagittariusInvocationRef = useRef(null);
  const capricornInvocationRef = useRef(null);
  const aquarisInvocationRef = useRef(null);
  const piscesInvocationRef = useRef(null);

  const standardBanishingRef = useRef(null);
  const standardDivineInfiniteRef = useRef(null);
  const planetaryInvocationRef = useRef(null);
  const zodiacalInvocationRef = useRef(null);
  const invocationOfTheRef = useRef(null);
  const finalPronouncementRef = useRef(null);
  const hermesApolloRef = useRef(null);
  const openingOfTheGatesRef = useRef(null);
  const planetaryIntelligenciesRef = useRef(null);
  const theSunArchetypeRef = useRef(null);
  const theMoonArchetypeRef = useRef(null);
  const theUranusArchetypeRef = useRef(null);
  const theNeptuneArchetypeRef = useRef(null);
  const thePlutoArchetypeRef = useRef(null);
  const alignmentWithTheZodiacRef = useRef(null);
  const theMercuryArchetype = useRef(null);
  const theVenusArchetype = useRef(null);
  const theMarsArchetype = useRef(null);
  const theJupiterArchetype = useRef(null);
  const theSaturnArchetype = useRef(null);

  const scrollToSection = (ref) => {
    console.log("scrollToSection called with ref:", ref);

    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Head>
        <title>
          Theurgic Ritual & Invocation of the Gods | School of Our Divine
          Infinite Being
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Theurgic Ritual, Invocation of the Gods, Ritual Praxis, Theurgy, Divine Gnosis, Oracular, Depth Psychology, Jungian Archetypes, Neoplatonism, Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="The Foundation of Theurgic Ritual & Invocation"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/School_Rituals_OG_Image.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="A robed practitioner stands in a sacred space, performing a theurgic ritual of invocation with arms raised, surrounded by mystical symbols."
        ></meta>
        <meta
          property="og:description"
          content="Explore the foundations of theurgic ritual and the invocation of the gods at our school. Learn how we blend ancient ritual praxis with depth psychology to achieve authentic oracular communion and divine gnosis."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/ritual-praxis"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/School_Rituals_OG_Image.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="A robed practitioner stands in a sacred space, performing a theurgic ritual of invocation with arms raised, surrounded by mystical symbols."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/ritual-praxis"
        ></meta>
        <meta
          name="twitter:title"
          content="The Foundation of Theurgic Ritual & Invocation"
        ></meta>
        <meta
          name="twitter:description"
          content="Explore the foundations of theurgic ritual and the invocation of the gods at our school. Learn how we blend ancient ritual praxis with depth psychology to achieve authentic oracular communion and divine gnosis."
        ></meta>
        <link
          rel="canonical"
          href="https://www.divineinfinitebeing.com/ritual-praxis"
        />
      </Head>

      {/* <div className={styles.school_ritual_TotalPage_mainWrp}> */}
        <div className={styles.ritualpraxis_blockone}>
          <Link href="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/school_ritual/Quick-Reference-Guide.pdf" target="_blank"><button className={styles.ritualpraxis_blockone_btn_banner}>
            Quick Reference Guide
            <img src="/image/ritualpraxis_blockone_btn_banner_icon.png"/>
            </button></Link>
          {/* {/ <!------Main Banner section-------> /} */}
          <div className={styles.ritualpraxis_banner_main_wrpr}>
            <div className={styles.ritualpraxis_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="view_icon"
                  />
                </span>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                  alt="banner_logo"
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.ritualpraxis_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew/>

        {/* ----------------block1-------------------- */}

        {/* <div className={styles.psd1_whole_bg}> */}
        <LazySection>
          <div className={styles.school_ritual_block1_mainWrp}>
            <div className={styles.common_width}>
              <div className={styles.school_ritual_block1_main_Sub_Wrp}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h2>RITUAL PRAXIS OF THE SCHOOL OF OUR DIVINE INFINITE BEING</h2>
                  </div>
                </div>

                <div className={styles.school_ritual_block1_sec_main}>
                  <ul className={styles.school_ritual_block1_sec_ul}>
                    <li onClick={() => scrollToSection(ritualPraxisRef)}>
                      THEURGICAL RITUAL AND THE INVOCATION OF THE GODS
                    </li>
                    <li onClick={() => scrollToSection(theResonateNatureRef)}>
                      THE RESONATE NATURE OF THE DIVINE NAMES
                    </li>
                    <li onClick={() => scrollToSection(theTheurgicRitualRef)}>
                      THE THEURGIC RITUAL OF THE PENTAGRAM
                    </li>
                    <li
                      className={styles.school_ritual_block1_sec_ul_li_arrow}
                      onClick={() => scrollToSection(theFiveStandardPentaSet)}
                    >
                      THE FIVE STANDARD PENTAGRAM RITUAL SETS
                    </li>
                    <div
                      className={
                        styles.school_ritual_block1_sec_ul_flx_outsidewrap
                      }
                    >
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li
                          onClick={() =>
                            scrollToSection(banishingInvocationRitual)
                          }
                        >
                          Banishing/invocation ritual
                        </li>
                        <li
                          onClick={() =>
                            scrollToSection(divineInfiniteInvocationRitual)
                          }
                        >
                          Divine Infinite Being
                          <br /> Invocation Ritual{" "}
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li
                          onClick={() =>
                            scrollToSection(planetaryInvocationRitual)
                          }
                        >
                          Planetary Invocation Ritual
                        </li>
                        <li
                          onClick={() =>
                            scrollToSection(zodiacalInvocationRitual)
                          }
                        >
                          Zodiacal Invocation Ritual
                        </li>
                        <li
                          onClick={() =>
                            scrollToSection(celestialInvocationRitual)
                          }
                        >
                          Celestial Invocation Ritual
                        </li>
                      </ul>
                    </div>
                    <li
                      className={styles.school_ritual_block1_sec_ul_li_arrow}
                      onClick={() => scrollToSection(grandTheurgicInvocation)}
                    >
                      THE GRAND INVOCATION
                    </li>
                    <div
                      className={
                        styles.school_ritual_block1_sec_ul_flx_outsidewrap
                      }
                    >
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li
                          onClick={() =>
                            scrollToSection(introGrandTheurgicInvocation)
                          }
                        >
                          Introduction to the
                          <br /> Grand Invocation
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li onClick={() => scrollToSection(theMacrocosmicRef)}>
                          Macrocosmic Invocation
                        </li>
                        <li onClick={() => scrollToSection(theMicrocosmicRef)}>
                          Microcosmic Invocation
                        </li>
                      </ul>
                    </div>
                  </ul>

                  <ul className={styles.school_ritual_block1_sec_ul}>
                    <li onClick={() => scrollToSection(aligningTheElementsRef)}>
                      CASTING OF THE PENTAGRAMS - ALIGNING THE DEMIURGOS
                    </li>
                    <li onClick={() => scrollToSection(invocationOfTheRef)}>
                      INVOCATION OF THE GUARDIAN DAEMONS
                    </li>
                    <li onClick={() => scrollToSection(finalPronouncementRef)}>
                      FINAL PRONOUNCEMENT - CLOSING OF THE RITUAL
                    </li>
                    <li
                      onClick={() =>
                        scrollToSection(invocationOfDivineInfiniteBeing)
                      }
                    >
                      INVOCATION OF OUR DIVINE INFINITE BEING
                    </li>
                    <li onClick={() => scrollToSection(hermesApolloRef)}>
                      INVOCATION OF HERMES-APOLLO
                    </li>
                    <li onClick={() => scrollToSection(openingOfTheGatesRef)}>
                      OPENING OF THE GATES
                    </li>
                    <li onClick={() => scrollToSection(planetaryDecagramRef)}>
                      Planetary Symbolic Decagram
                    </li>
                   
                    <li onClick={() => scrollToSection(planetaryResonanceRef)}>
                      PLANETARY RESONANCE IN PREPARATION
                    </li>
                  </ul>
                  <ul className={styles.school_ritual_block1_sec_ul}>
                    <li
                      className={styles.school_ritual_block1_sec_ul_li_arrow}
                      onClick={() =>
                        scrollToSection(planetaryIntelligenciesRef)
                      }
                    >
                      THE PLANETARY ARCHETYPES AND DIVINE INTELLIGENCES
                    </li>
                    <div
                      className={
                        styles.school_ritual_block1_sec_ul_flx_outsidewrap
                      }
                    >
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li onClick={() => scrollToSection(theSunArchetypeRef)}>
                          Sun Invocation{" "}
                        </li>
                        <li
                          onClick={() => scrollToSection(theMoonArchetypeRef)}
                        >
                          Moon Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(theMercuryArchetype)}
                        >
                          Mercury Invocation
                        </li>
                        <li onClick={() => scrollToSection(theVenusArchetype)}>
                          Venus Invocation
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li onClick={() => scrollToSection(theMarsArchetype)}>
                          Mars Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(theJupiterArchetype)}
                        >
                          Jupiter Invocation
                        </li>
                        <li onClick={() => scrollToSection(theSaturnArchetype)}>
                          Saturn Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(theUranusArchetypeRef)}
                        >
                          Uranus Invocation
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li
                          onClick={() =>
                            scrollToSection(theNeptuneArchetypeRef)
                          }
                        >
                          Neptune Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(thePlutoArchetypeRef)}
                        >
                          Pluto Invocation
                        </li>
                      </ul>
                    </div>

                    <li
                      className={styles.school_ritual_block1_sec_ul_li_arrow}
                      onClick={() => scrollToSection(alignmentWithTheZodiacRef)}
                    >
                      ALIGNMENT WITH THE ZODIAC - THE HOUSE OF THE SUN
                    </li>
                    <div
                      className={
                        styles.school_ritual_block1_sec_ul_flx_outsidewrap
                      }
                    >
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li onClick={() => scrollToSection(ariesInvocationRef)}>
                          Aries Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(taurasInvocationRef)}
                        >
                          Taurus Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(geminiInvocationRef)}
                        >
                          Gemini Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(cancerInvocationRef)}
                        >
                          Cancer Invocation
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li onClick={() => scrollToSection(leoInvocationRef)}>
                          Leo Invocation
                        </li>
                        <li onClick={() => scrollToSection(virgoInvocationRef)}>
                          Virgo Invocation
                        </li>
                        <li onClick={() => scrollToSection(libraInvocationRef)}>
                          Libra Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(scorpioInvocationRef)}
                        >
                          Scorpio Invocation
                        </li>
                      </ul>
                      <ul className={styles.school_ritual_block1_sec_ul_flx}>
                        <li
                          onClick={() =>
                            scrollToSection(sagittariusInvocationRef)
                          }
                        >
                          Sagittarius Invocation
                        </li>
                        <li
                          onClick={() =>
                            scrollToSection(capricornInvocationRef)
                          }
                        >
                          Capricorn Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(aquarisInvocationRef)}
                        >
                          Aquarius Invocation
                        </li>
                        <li
                          onClick={() => scrollToSection(piscesInvocationRef)}
                        >
                          Pisces Invocation
                        </li>
                      </ul>
                    </div>
                     <li onClick={() => scrollToSection(natalIncarnationRef)}>
                      THE NATAL INCARNATION OF THEURGIC UNION
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        <div className={styles.school_ritual_blocks_mainWrp}>
          <div className={styles.psd1_whole_bg}>
            {/* -------------------------block1New------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_block2_mainWrp} ${styles.school_ritual_block1_mainWrp_new}`}
                ref={ritualPraxisRef}
              >
                <div className={styles.common_width}>
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h2>THEURGIC RITUAL AND THE INVOCATION OF THE GODS</h2>
                    </div>
                  </div>

                  <div
                    className={`${styles.school_ritual_block2_main_Sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2>
                        <span>
                          The Oracular Foundation of <br />
                          Theurgic Devotion
                        </span>{" "}
                      </h2>
                      <p>
                        <span>
                          "The Generic variety of Old Babylonian omen compendia
                          is wide. Most texts are witnesses to the scholarly
                          traditions of impetrated divination, i.e. oracles
                          induced by ritual."
                        </span>
                      </p>
                      <h6>
                        <i>
                          — A.R. George, Babylonian Divination Texts Chiefly in
                          the Schoyen Collection
                        </i>
                      </h6>

                      <p>
                        From the earliest millennia of recorded civilization,
                        the human pursuit of divine contact through ritual has
                        stood at the center of spiritual practice. In ancient
                        Babylonia, the scholar-diviners developed a meticulous
                        art of impetrated divination—oracular experience
                        deliberately induced through ritual acts. These rites
                        were not merely symbolic, but operative: carefully
                        constructed procedures meant to open channels between
                        the material and divine realms, calling forth responses
                        from gods, celestial intelligences, or daemonic
                        intermediaries.
                      </p>
                      <p>
                        In the School of our Divine Infinite Being, we
                        acknowledge and honor this ancient lineage. Though our
                        theurgic system is advanced in its metaphysical
                        architecture and informed by a synthesis of Platonic,
                        Vedantic, and esoteric wisdom traditions, it shares with
                        the Babylonian priests the most essential aim: to induce
                        authentic oracular communion through ritual means.
                      </p>
                      <p>
                        Our praxis does not seek revelation through passive hope
                        or vague mysticism. Like the ancients, we approach the
                        Divine through structured ceremonial engagement. Each
                        rite, invocation, and act of consecration is crafted
                        with precision to pierce the veils of perceptual
                        limitation and allow the Infinite to speak—not only
                        symbolically, but directly, through the living oracle of
                        the awakened soul.
                      </p>
                      <p>
                        The rituals of this School are instruments of oracular
                        divination and divine astrological theurgy — sanctified
                        technologies through which the eternal responds in
                        ritual praxis. In this way, we become not only
                        practitioners, but oracles ourselves, aligned with the
                        divine archetype that animates the cosmos and reveals
                        itself when sincerely called upon.
                      </p>
                      <p>
                        Let our ceremonial rites begin in reverence—and with
                        full recognition that in reaching toward the heavens, we
                        walk paths traced by the oldest of initiates, who knew
                        as we do that ritual is the bridge to revelation.
                      </p>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/school_ritual/school_ritual_block1_mainWrp_new_bg.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* ----------------6AugNewBlock1------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_block2_mainWrp} ${styles.school_ritual_block_mainWrp_6AugNewBlock1}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_block2_main_Sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <p>
                        Our approach to Divine Theurgy is not merely rooted in
                        ancient tradition—it is dynamically engaged with the
                        most profound insights of contemporary science and
                        psychology. We teach that quantum mechanics, string
                        theory, quantum biology and the principles of
                        information theory offer a powerful metaphysical
                        framework for understanding how theurgy operates at the
                        deepest levels of reality.
                      </p>
                      <p>
                        In particular, the{" "}
                        <span>holographic model of the universe</span>, which
                        posits that the cosmos is fundamentally composed of
                        encoded information projected from a deeper dimensional
                        order, aligns seamlessly with the metaphysical
                        assumptions of theurgical practice. The{" "}
                        <span>observer effect</span> in quantum mechanics—where
                        the act of observation collapses a probability wave into
                        a concrete reality— mirrors the conscious engagement of
                        the theurgist who, through focused will and reverent
                        alignment, calls divine order into expression.
                      </p>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="/image/ritual_6AugNewBlock1_img.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* ----------------6AugNewBlock2------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_block2_mainWrp} ${styles.school_ritual_block1_mainWrp_new} ${styles.school_ritual_block_mainWrp_6AugNewBlock2}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_block2_main_Sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <p>
                        Moreover, we draw from depth psychology—especially the
                        Jungian theory of archetypes—and the Transconscious Egg
                        map of consciousness to illuminate the inner dimension
                        of theurgy. The planetary gods are not only cosmogonic
                        divine intelligences, wholes beyond comprehension, but
                        also living symbols within the psyche—a psycho-spiritual
                        technology through which the aspirant becomes an active
                        participant in the unfolding of Being.
                      </p>
                      <p>
                        To fully understand and apply these integrative
                        modalities within the sacred art of theurgy, it is
                        essential to study our <span>Central Doctrine</span> as
                        a companion to this work, where these correspondences
                        are explored in depth and contextualized within our full
                        ritual framework.
                      </p>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="/image/ritual_6AugNewBlock2_img.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* ---------------------block2-------------------- */}

            <LazySection>
              <div className={styles.school_ritual_block2_mainWrp}>
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_block2_main_Sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <p>
                        Theurgists aim to directly know, experience, and connect
                        with the eternal, divine principles of existence.
                        Iamblichus, considered the founder of theurgic Platonic
                        practices, emphasized that theurgy transcends ordinary
                        prayer, meditation, or philosophical inquiry. It
                        establishes a dynamic relationship with the divine,
                        requiring significant ritual activity to bring the
                        divine into direct perception. While divine intelligence
                        in its many forms is present everywhere in the natural
                        world, the theurgic realms tend to be inaccessible and
                        remain mostly unknown through conventional methods.
                        Accessing these previously hidden dimensions of nature
                        requires disciplined and dedicated practice. In essence,
                        theurgy is not simply observing the divine in the world
                        around us, but actively participating in it through
                        specific, ritualized practices.
                      </p>
                      <p>
                        Iamblichus stated in De Mysteriis,{" "}
                        <span>
                          "It is not, therefore, through philosophy that we can
                          come into contact with this [divine] cause, but
                          through a power more ineffable and higher than all
                          abstraction. … For the accomplishment of contact with
                          the divine, which we achieve more effectively than
                          through all reasoning and all knowledge, and for the
                          possession of the first, ineffable, and truly divine
                          operations and divine energy, no other process except
                          theurgy is competent."
                        </span>{" "}
                        You could read every scroll in the Alexandrian library
                        and memorize every rule of quantum mechanics, but
                        without consistent dedicated practice, this realm of
                        experience remains unknown. The reasons for this are
                        more practical than anything else.
                      </p>
                      <p>
                        In theurgy, you cultivate the visionary and auditory
                        capacities necessary to perceive the objective body of
                        light and the transconscious, immortal divine double
                        enthroned upon the ōchema, the spherical star vehicle.
                        You access the visionary astral plane of eternal
                        archetypes and the divine intelligences of the Platonic
                        Forms in direct, relational unity. The mind ceases to be
                        a wandering, ever-changing landscape. Here, the
                        imagination is stilled and empowered, transforming the
                        visionary field into a consecrated vessel for the
                        invocation of the divine.
                      </p>
                      <p>
                        The objective nature of this relationship is only
                        understood by the theurgist upon experiencing. You can
                        imagine how it works in the mind, but experiencing it is
                        something else altogether. This is a transformation of
                        the soul, and for many, the experiences in theurgy are
                        more real than those of everyday waking life. The only
                        way to know this is to engage the practice faithfully
                        with an open heart and mind.
                      </p>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/block2_image_bg.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block3-------------------- */}
            <LazySection>
              <div className={styles.school_ritual_block3_mainWrp}>
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_block3_main_Sub_Wrpr} ${styles.flx_wrpr}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <p>
                        <span>
                          “The psychic organ that received the divine light was
                          the pneumatic or luminous body. In his treatise On
                          Dreams, Synesius identified this body with the
                          "imagination" and described it as the soul's "first
                          vehicle". It was within this imaginal body that the
                          soul experienced its most profound illuminations. The
                          imaginal body, however, should not be confused with
                          ordinary imagination. Iamblichus distinguished not
                          only the "god-sent" dreams from the "human" but also
                          the "divine appearances" given by the gods from the
                          images concocted by man. The former possessed
                          transformative power while the latter were merely
                          reflections of embodied life”.
                        </span>
                      </p>
                      <h6>
                        <i>
                          - Gregory Shaw, Theurgy and the Soul, The Neoplatonism
                          of Iamblichus
                        </i>
                      </h6>
                      <p>
                        In our Central Doctrine we speak of Jñana yoga which
                        provides a key analogy for understanding theurgy. As
                        Timothy Desmond states, Jñana yoga is{" "}
                        <span>
                          "the bending of one's mind into shapes that, when held
                          for a significant amount of time, releases knowledge."
                        </span>{" "}
                        Just as Hatha yoga involves holding physical postures,
                        Jñana yoga involves holding mental postures. This is
                        precisely what we do in theurgic ritual.
                      </p>
                      <p>
                        Sustained focus on a specific form or intention within
                        the ritual unlocks hidden knowledge, manifesting within
                        the imaginal or astral body. This extended concentration
                        expands awareness, granting the theurgist ecstatic,
                        direct visionary, and divinatory experiences. The
                        visionary self is infused with divine light, and the
                        normally fleeting imagination is anchored to potent
                        symbolic imagery. This process allows us to directly
                        experience the fundamental, ontological principles of
                        divine reality—the very ground of being.
                      </p>
                      <p>
                        Because we so rarely hold anything within our
                        imagination in a state of sustained, direct experience,
                        this process is often profoundly unfamiliar and,
                        especially initially, can be overwhelming. However, with
                        dedicated practice, this theurgic discipline becomes a
                        powerful and practical method for directly engaging
                        eternal principles, invoking divine intelligences—Gods,
                        Goddesses, daemons, zodiacal and planetary forces. This
                        is not passive contemplation; it is active participation
                        in the divine.
                      </p>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/block3_image_bg.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
            {/* -----------------------block4-------------------- */}

            <LazySection>
              <div className={styles.school_ritual_block4_mainWrp}>
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_block4_main_Sub_Wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <p>
                        <span>
                          “All of theurgy has a two-fold character. One is that
                          it is a rite conducted by men which preserves our
                          natural order in the universe; the other is that it is
                          empowered by divine symbols (sunthemata) raised up
                          through them to be joined on high with the gods and is
                          led harmoniously round to their order. This latter
                          aspect can rightly be called{" "}
                          <span>‘taking the shape of the gods.”</span>
                        </span>
                      </p>
                      <h6>
                        <i>- Iamblichus, De Mysteriis</i>
                      </h6>
                      <p>
                        <span>
                          "…the God or divine essence invoked invariantly
                          incarnates in the Magician’s being, by means of the
                          consecrated substance."
                        </span>
                      </p>
                      <h6>
                        <i>
                          - Israel Regardie, The Tree of Life a study in Magic
                        </i>
                      </h6>
                      <p>
                        The practice of both theurgic rituals and raja-kundalini
                        centers on the practitioner's ability to cultivate and
                        maintain a vibrant imaginal landscape. As symbolic
                        visualizations are invoked, they must be held
                        steadfastly within the mind's eye, even as other divine
                        symbols, <span>"sunthemata,"</span> are integrated as
                        the ritual progresses. This sustained imaginal focus
                        facilitates a form of divine <span>"incarnation,"</span>{" "}
                        fusing abstract symbols with tangible, experiential
                        union with archetypes, deities, and spiritual entities.
                        Iamblichus' predicate of{" "}
                        <span>"taking the shape of the gods,"</span> is key to
                        this transformative process, achieved through the
                        structured practice of theurgic ritual and{" "}
                        <span>“tuned in”</span> through consistent ceremonial
                        repetition. This aligns with the core principles
                        outlined in our Central Doctrine, which provides further
                        detail on this process.
                      </p>
                      <p>
                        <span>
                          “The light-like primordial sound, pronounced by the
                          supreme Creator or the Ennead of gods is characterized
                          by miraculous force; therefore the world is this
                          transcendent sound and the living (ankh) noetic (akh)
                          image (tut) made substantial. The divine words, imbued
                          with demiurgic and theurgic powers (hekau, analogous
                          to the Hindu mantras) have animating, purifying,
                          transforming, and elevating powers. They are the
                          onomata barbara, nomina barbara praised by the
                          Chaldean Oracles (fr.107).”
                        </span>
                      </p>
                      <h6>
                        <i>
                          {" "}
                          — Algis Uždavinys, Philosophy as a Rite of Rebirth
                        </i>
                      </h6>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block4_image_bg.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block4_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block5-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block5_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          Gregory Shaw, in Platonic Tantra, illuminates the
                          striking parallels between theurgy and Tantra,
                          particularly their shared methodology of divine
                          embodiment. He states,{" "}
                          <span>
                            "In both theurgy and Tantra the initiate enters into
                            the 'body' of the god through the performance of
                            rituals. Through the chanting of mantras in Tantra
                            and divine names in theurgy the initiate unites with
                            the gods through their sounds, and through entering
                            the god's audible body the theurgist and tantric
                            initiate become that god in embodied form. Their
                            orientation fundamentally shifts; they enter divine
                            totalities; they assume divine power. And in both
                            traditions to enter this pulse of divine activity:
                            the spanda of Tantra or the proodos-epistrophe of
                            theurgy, the initiate must first ascend to the
                            divine cause and then descend, having become
                            identified with the activity of the god."
                          </span>
                        </p>

                        <p>
                          Shaw's analysis reveals the mechanics of this divine
                          embodiment. The ritual performance, whether through
                          the chanting of mantras in Tantra or the invocation of
                          divine names in theurgy, serves as the vehicle for
                          entering the <span>"body"</span> of the god. This{" "}
                          <span>"body"</span> is not merely physical but
                          encompasses the complex of energies and attributes
                          associated with the deity, accessed through sound and
                          symbolic representation. The practitioner's
                          vocalizations create a resonant connection,
                          effectively embodying the god's audible form and
                          thereby uniting with the divine. This sonorous sonic
                          union facilitates a profound shift in the
                          practitioner's being, granting access to divine
                          totality and empowering them with divine agency.
                        </p>

                        <p>
                          Shaw emphasizes the dynamic nature of this
                          transformative process, describing it in terms of the
                          Tantric concept of spanda{" "}
                          <span>
                            (a pulsation or vibration of divine energy) and the
                            Neoplatonic proodos-epistrophe (the procession and
                            return)
                          </span>
                          . Proodos, the <span>"going forth,"</span> describes
                          the emanation of reality from the One, the ultimate,
                          transcendent source. This emanation unfolds
                          hierarchically, from the One to the Intellect{" "}
                          <span>(Nous)</span>, then to the Soul, and finally to
                          the material world. The gods, goddesses, daemons,
                          divine intelligences, archetypes, and all forms are
                          understood as aspects of this unfolding, directly
                          accessible through theurgic union. Epistrophe, the{" "}
                          <span>"return,"</span> describes the complementary
                          process by which all beings strive to return to the
                          One. An ascent achieved through self-awareness,
                          philosophical contemplation, and most effectively,
                          through theurgic practice. Theurgic ritual praxis,
                          therefore, facilitates the integration of the material
                          world of experience with the ascent toward the
                          Intellect and ultimately, union with the One, the
                          absolute, our Divine Infinite Being.{" "}
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block5_image_bg.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block5_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
            {/* -----------------------block6-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block6_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        {/* <p>
                                                <span>“All of theurgy has a two-fold character. One is that it is a rite conducted by men which preserves our natural order in the universe; the other is that it is empowered by divine symbols (sunthemata) raised up through them to be joined on high with the gods and is led harmoniously round to their order. This latter aspect can rightly be called ‘taking the shape of the gods.”</span>

                                            </p>
                                            <h6><span>- Iamblichus, De Mysteriis</span></h6>

                                            <p><span>"…the God or divine essence invoked invariantly incarnates in the Magician’s being, by means of the consecrated substance."</span></p>
                                            <h6><span>- Israel Regardie, The Tree of Life a study in Magic</span></h6>



                                            <p>
                                                The practice of both theurgic rituals and raja-kundalini centers on the practitioner's ability to cultivate and maintain a vibrant imaginal landscape. As symbolic visualizations are invoked, they must be held steadfastly within the mind's eye, even as other divine symbols, <span>"sunthemata,"</span> are integrated as the ritual progresses. This sustained imaginal focus facilitates a form of divine <span>"incarnation,"</span> fusing
                                                abstract symbols with tangible, experiential union with archetypes, deities, and spiritual entities.
                                                Iamblichus' predicate of <span>"taking the shape of the gods"</span> is key to this transformative process, achieved through the structured practice of theurgic ritual and <span>“tuned in”</span> through consistent ceremonial
                                                repetition. This aligns with the core principles outlined in our Central Doctrine, which provides further detail on this process.  </p> */}
                        <p>
                          To participate in this divine pulse—the spanda or
                          proodos-epistrophe—the initiate must, as Shaw states,
                          first ascend to the divine source and then descend,
                          fully identified with the god's activity. This ascent
                          and descent, this divine embodiment, is made possible
                          through sustained imaginal work—the cultivation and
                          maintenance of symbolic visualizations. This imaginal
                          practice forms the very mechanism by which the
                          theurgic ascent and return occur. This central
                          principle of theurgic ritual praxis, the ascent and
                          return, is a core tenet of our Central Doctrine and is
                          also the organizing principle of the Grand Invocation
                          within our Pentagram Ritual.
                        </p>

                        <p>
                          To invoke a god, daemon, planet, or divine
                          intelligence in theurgic ritual is not to summon a
                          fragmentary force, but to enter into relation with a{" "}
                          <span>living wholeness</span>—a presence whose nature
                          utterly exceeds comprehension. These intelligences are
                          not constructed by thought; they are{" "}
                          <span>constitutive of it</span>. They are not mythic
                          personifications of internal processes, but <span>ontic
                            beings</span> who dwell at strata of reality beyond what the
                          modern mind calls <span>“real.”</span> And yet, the
                          ritual space makes contact possible. It is in this
                          encounter—where the visible meets the invisible, where
                          the limited self stands before the plenitude of divine
                          totality—that the true power of{" "}
                          <span>counter-intuition</span> is revealed.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block6_image_bg.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block6_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -------------------6AugNewBlock3-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block7_mainWrp} ${styles.school_ritual_block7_mainWrp_6AugNewBlock3}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          This is achieved through a{" "}
                          <span>“Suprarationality,”</span> as Iamblichus has
                          taught, akin to Rabbi Yitzchak Ginsburgh’s explanation
                          of <span>“counter-intuition”</span> in Kabbalistic
                          terms, which is not the negation of logic or the
                          rejection of reason. Rather, it is the <span>recognition
                            that every level of consciousness possesses its own{" "}
                            “common sense.”</span> In the Kabbalistic
                          schema, each World—each ontological layer of mind and
                          being—has its own framework for what is self-evident.
                          From within a lower World, the principles of the
                          higher seem absurd, paradoxical, or impossible. As
                          consciousness ascends, these impossibilities become
                          natural, obvious, and coherent. The counter-intuitive
                          becomes the open gate as our being is <span>transfigured</span> to
                          receive it.
                        </p>

                        <p>
                          This is the inner mechanism of theurgic vision. The
                          gods do not enter through belief, imagination, or
                          suggestion. They appear because the theurgist is drawn
                          up—or drawn in—through ritual ascent to the <span>World
                            proper to the god’s being</span>. The name, the gesture, the
                          alignment of attention—these do not cause the vision;
                          they <span>condition the field</span> in which the god may become
                          visible. What seems irrational to the ordinary self is
                          in fact the <span>proper logic</span> of the divine. It only
                          appears irrational because it belongs to a higher
                          order.
                        </p>
                        <p>
                          This principle may be glimpsed even in the invocation
                          of a planetary intelligence such as <span>Saturn</span>, whose
                          effects ripple visibly through the field of human life
                          and fate. In the discursive realm, Saturn’s influence
                          is observable: the pressure of time, the demands of
                          discipline, the cold perfection of form, the austerity
                          that hardens wisdom into structure. We see Saturn in
                          the long arc of a life shaped by delay and
                          perseverance, in the sorrow that becomes refinement,
                          in the responsibility that forges the soul. A single
                          individual may experience Saturn as hardship,
                          solitude, or inward gravity—but these glimpses are
                          only <span>surface fractures of a far deeper Whole</span>.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="/image/ritual_6AugNewBlock3_img.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="/image/ritual_6AugNewBlock3_img.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -------------------6AugNewBlock4-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block6_mainWrp} ${styles.school_ritual_block6_mainWrp_6AugNewBlock4}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          For Saturn is not merely a planet or force—it is a <span>numinous intelligence</span>, whose full nature includes the
                          simultaneous orchestration of karmic consequences,
                          historical epochs, initiatory thresholds, ancestral
                          memory, and death’s transmutative gate. Its reality
                          encompasses <span>billions of lives across time and space,</span> shaping destinies beyond comprehension. The rational
                          mind sees Saturn’s imprint on the form of things; but
                          the theurgic invocation of Saturn allows the eternal
                          Saturnine intelligence to <span>imprint itself on the soul</span>.
                          Through ritual embodiment, Saturn’s suprarational
                          order is no longer interpreted—it is <span>experienced</span>.
                        </p>

                        <p>
                          In that moment, what was once distant and austere
                          becomes radiant and inwardly alive. Through the act of
                          counter-intuition, the theurgist yields the persona to
                          the transconscious immensity of Saturn’s infinite
                          intelligence, beyond all bounds of time and space.
                          Saturn takes hold of the theurgist, impressing its
                          presence through every fiber until the eternal nature
                          of its being becomes both vision and substance. The
                          soul, refined through this surrender, knows the
                          Saturnine not as alien fate but as divine necessity,
                          whose hidden mercy grants structure and the freedom
                          born of limit. The theurgist is transformed in full
                          alignment with the god’s own noetic rhythm, whose
                          order moves beyond the mind’s circumference.
                        </p>
                        <p>
                          This idea is echoed with precise clarity in the
                          tantric metaphysics of the Śrī Tantrāloka, where
                          ritual action{" "}
                          <span>
                            <i>(kriyā)</i>
                          </span>{" "}
                          and mantra{" "}
                          <span>
                            <i>(uccāra)</i>
                          </span>{" "}
                          are understood as ontological technologies that draw
                          Śakti into manifest presence. In Abhinavagupta’s view,
                          the divine does not <span>“come down”</span> through ritual.
                          Rather, the ritual reconfigures the practitioner’s
                          awareness so that it can dwell where the divine
                          already abides. This vibrational co-emergence refines
                          the layers of self; as ordinary cognition is bypassed,
                          the higher vision-body{" "}
                          <span>
                            <i>(divya-deha)</i>
                          </span>{" "}
                          begins to operate. The god does not merely appear to
                          you — the god appears as you, within you, through you;
                          the two are merged into one total, transient,
                          experiential ontology.
                        </p>
                        <p>
                          The same principle governs Iamblichean theurgy.
                          According to Iamblichus, the gods are wholes—perfect,
                          undivided noetic totalities that transcend thought and
                          image. They are reached not through intellection, but
                          through ritual union. In theurgic rites, the soul
                          aligns sympathetically with the god’s own noetic
                          rhythm, entering direct resonance. What follows is the
                          living impress of divine fullness upon a soul opened
                          beyond itself, a presence that takes root in the
                          depths and reorders the whole being.
                        </p>
                        <p>
                          Thus, counter-intuition becomes the <span>gateway</span> into
                          theurgic truth. It marks the threshold where common
                          sense gives way to divine sense. It is not a rejection
                          of reason, but the moment where reason is <span>overtaken</span> by
                          something greater—where thought yields to vision,
                          where invocation gives way to embodiment. The gods are
                          not made real by belief. They are revealed when the
                          theurgist leaves behind the <span>“natural”</span>{" "}
                          sense of the lower World and steps into the <span>supernatural logic of the divine</span>.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="/image/ritual_6AugNewBlock4_img.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="/image/ritual_6AugNewBlock4_img.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* ------------------------block7--------------------  */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block7_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The reason for performing a ritual daily, or over a
                          span of a lengthy dedicated period, is to maintain
                          every single attribute of the ritual within your
                          astral body, your imaginal being, simultaneously from
                          the very first invocation to the closing of the
                          ceremony. Those who have engaged in this process for
                          several weeks understand the trajectory of this
                          endeavor. As you continue to combine different aspects
                          of the ritual, there is an exaltation that occurs.
                          This <span>"peak"</span> in the ritual, as you will
                          experience, is a continuous transformation of the soul
                          that progressively deepens the theurgist's connection
                          to divine knowledge with each successive performance.
                        </p>

                        <p>
                          Theurgy is a lifelong pursuit, akin to philosophical
                          inquiry; far beyond mere education—a{" "}
                          <span>“pedia”</span>—it is a transformative path of
                          continuous ritualized awakening. To sustain and
                          regulate the work, it is best practiced several times
                          a week or even daily combined with other practices
                          such as Raja-Kundalini.
                        </p>

                        <p>
                          For the theurgist, consistent, shorter ritual practice
                          is more effective than infrequent, lengthy ceremonies.
                          While some traditions advocate extended, multi-hour
                          rituals, these can be disruptive to modern life and
                          ultimately less productive. The key is daily
                          dedication, even if it's just for 20-45 minutes daily
                          or a few times a week. This regular rhythm fosters
                          deeper, more sustained spiritual development than
                          sporadic, marathon sessions. Even complex invocations
                          and meditations should rarely exceed an hour.
                          Prioritizing consistent, manageable ritual work
                          integrates seamlessly into daily life, fostering
                          natural and sustained growth in theurgic practice.
                          This approach makes theurgy practical and achievable,
                          allowing for long-term progress without sacrificing
                          other commitments.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block7_image_bg.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block7_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
            {/* -----------------------block8-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block8_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          Many ceremonial based praxis utilize a sequence of
                          distinct rituals, often performed in a specific order.
                          Common examples include a banishing ritual followed by
                          a hexagram ritual, and then another banishing ritual
                          to close. Another common sequence is banishing, the
                          Middle Pillar ritual, the Mass of the Phoenix, and
                          then a final banishing. These basic structures can
                          become quite elaborate, with numerous additional
                          rituals woven into the sequence. Our school, however,
                          emphasizes a different approach. Our central ritual is
                          the Theurgic Ritual of the Pentagram, and all other
                          ritual work is framed within its structure.
                        </p>

                        <p>
                          Instead of performing separate, independent rituals in
                          succession, we integrate them as components of a
                          single, unified operation. This holistic approach is
                          crucial for maintaining focus and maximizing the
                          efficacy of theurgy. Performing a series of discrete
                          rituals, one after another, and especially
                          incorporating excessive psychodynamic elements,
                          dilutes the ritual's power and scatters the operator's
                          energy. By containing all ritual actions within the
                          framework of one grand operation—the Theurgic Ritual
                          of the Pentagram—we create a consistent and powerful{" "}
                          <span>"body of light,"</span> fostering a deep sense
                          of centralization for the theurgist. This unified
                          structure supports momentum and amplitude maintaining
                          a clear, unbroken connection to the divine energies
                          being invoked.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="/image/school_ritual_block8_image_bg_new_6Aug.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* ------------------------block9--------------------  */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block9_mainWrp}`}
                ref={theResonateNatureRef}
              >
                <div className={styles.common_width}>
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h2>THE RESONATE NATURE OF THE DIVINE NAMES</h2>
                    </div>
                  </div>

                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          <span>
                            “Thus the language is that of incantations and
                            Mantras as they are called in India, sound being the
                            most potent and effectual magic agent, and the first
                            of the keys which opens the door of communication
                            between mortals and Immortals.”
                          </span>
                        </p>
                        <h6>
                          <span>
                            - Israel Regardie, The Tree of Life a study in Magic
                          </span>
                        </h6>

                        <p>
                          The Divine Names are employed in various ways across
                          many mystery schools and religious systems. In some
                          contexts, they are melodic, resembling a song
                          performed repeatedly. In others, they are used in a
                          trance-like manner, often chanted in a deep, circular
                          voice. Finally there is the use of these resonant
                          Divine Names as we utilize through the theory of
                          octaves.
                        </p>

                        <p>
                          Performing rituals that involve the Divine Names
                          creates a vertical experience linked to both the
                          visionary luminous body and the auditory sonorous rule
                          of octaves. When resonating the names, it's important
                          to listen for the octave, which is the same note
                          variance as your voice but shifted up by twelve notes.
                          These notes are identical, only differentiated by
                          scale. By conditioning your voice to produce a
                          sonorous effect, you will be able to hear this octave
                          alongside your own voice, creating a dual sound as you
                          resonate the name. This technique requires practice,
                          but it can be demonstrated easily if we get a chance
                          to work together in person. We also have many videos
                          where we demonstrate these pronouncements on YouTube.
                        </p>
                        <p>
                          Once you generate and perceive this second octave,
                          shift your focus to{" "}
                          <span>"the octave that does not exist,”</span> which
                          is the third octave that would be 12 notes above the
                          second. This tripartite concentrated effort on the
                          resonation of the Divine Name gives you the sound of
                          your voice, the second octave as a tuning instrument,
                          and the third as an opening within the mind to hear
                          this octave that does not exist in the actual sound of
                          your voice, but does exist in the realm of experience
                          even if what you are doing is imagining its resonance.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      {/* <Image
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                                        alt=""
                                        width={298}
                                        height={201}
                                    /> */}

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg.webp"
                        alt="Image"
                      />

                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block9_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
            {/* -----------------------block10-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block10_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          <span>
                            “If the whole body of the Magician feels aflame with
                            force and energy, and thundering in his ears from
                            every surrounding portion of space he hears the
                            resounding echo of the name just magically vibrated,
                            he may rest assured that the pronouncement has been
                            correctly accomplished. The effect of the vibration
                            of the God-names is to set up a strain in the upper
                            astral light, in response to which the intelligence
                            evoked hastens… the most outstanding quality of
                            these conjurations is that the language used is
                            always very vibrant and sonorous.”
                          </span>
                        </p>
                        <h6>
                          <span>
                            - Israel Regardie, The Tree of Life a study in Magic
                          </span>
                        </h6>

                        <p>
                          By attending to the{" "}
                          <span>"sound that you cannot hear,"</span> you
                          stimulate the imaginal, visionary state of the ritual,
                          allowing you to{" "}
                          <span>"see what you cannot see."</span> This act of
                          listening for the imperceptible becomes the catalyst
                          for shaping the unseen. As Shaw notes, we enter into
                          the auditory body of the God, and in doing so, our
                          vision becomes aligned with, or even becomes, that
                          higher, vast agency of form. Through this profound
                          auditory connection, the divine perspective itself is
                          unveiled within us, allowing the God to see through
                          our eyes, while simultaneously we begin to perceive
                          existence through the God's specialized lens of
                          archetype and form. This process intensifies the
                          visionary experience associated with the luminous body
                          and amplifies the divinatory power of theurgic ritual
                          praxis. This powerful resonance can propel the
                          theurgist into sudden, profound visionary states,
                          directly instructing the soul through a rich pageant
                          of experience. This amplification arises naturally as
                          the theurgist refines their perception of sound,
                          focusing on the subtle octaves, ascending from the
                          audible world to the inner landscape of luminous
                          ritual transformation.
                        </p>
                        <p>
                          Just as crucial as the sonorous invocations of the
                          Divine Names is the silence that precedes and
                          punctuates them. This silence, observed with a finger
                          to the lips, provides an essential space for
                          integrating the imaginal work of the ritual. It allows
                          the practitioner to transition smoothly between
                          different phases of the invocation, maintaining a
                          clear and focused connection to the divine energies.
                          Between each invocation, a minimum of one deep,
                          natural breath is recommended. Two or three breaths
                          can further facilitate the process, allowing the
                          practitioner to settle more deeply into the invoked
                          atmosphere. However, one to three breaths will
                          generally suffice. Before beginning the ritual, it is
                          beneficial to completely quiet the mind for five to
                          ten full, deep breaths. This preparatory silence
                          establishes a strong foundation for the work to
                          follow. Upon completion of the ritual, it is
                          recommended to remain centered within the ritual
                          space, maintaining the gesture of silence, and
                          focusing on absorbing the residual energies generated
                          by the performance. This period of post-ritual silence
                          allows the practitioner to fully integrate the
                          experience and its effects. One should only break and
                          exit the ritual space once there is an intuitive sense
                          to depart.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block10_image_bg.webp"
                        alt="Image"
                      />
                      <img
                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block10_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block11-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block11_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div className={styles.column} ref={theTheurgicRitualRef}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h2>THE THEURGIC RITUAL OF THE PENTAGRAM</h2>
                    </div>
                  </div>

                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p><span>“He made my flesh into a flame, my sinews into blazing fire, my bones into burning coals, the light of my eyes into lightning, my eyelashes into flashes of light, the voice of my words into thunder and my appearance into the brightness of the sun, the light of the sun at the height of summer solstice.”</span></p>
                        <h6><span>— 3 Enoch 15:1–2</span></h6>
                        <p>
                          <span>
                            "Invocation says Imblichus, “is the divine key which
                            opens to men the penetralia of the gods; and
                            accustoms us to the splendid rivers of supernal
                            light; and in a short time disposes them for the
                            ineffable embrace and contact of the Gods; and does
                            not desist till it raises us to the summit of all.”
                          </span>
                        </p>
                        <h6>
                          <span>
                            {" "}
                            - Israel Regardie, The Tree of Life a study in Magic
                          </span>
                        </h6>

                        <p>
                          Engaging with the Pentagram Ritual entails a two-step
                          process: initial diligent study followed by practical
                          application. To navigate this practice effectively,
                          it's crucial to have a solid understanding of the
                          Central Doctrine. Reviewing or studying this doctrine
                          alongside developing your ritual practice will deepen
                          your engagement and enhance the overall effectiveness.{" "}
                        </p>

                        <p>
                          The Ritual of the Pentagram is distinguished by its
                          intricate dual growth modalities: the vocal harmonics
                          of <span>"resonance"</span> and the enhancement of the
                          imaginal body’s <span>"illumination."</span> This
                          dynamic interaction not only deepens the ritual but
                          also progressively attunes the practitioner into a
                          robust, luminous vessel for visionary experiences.
                          These experiences connect the theurgist with their
                          personal ochēma—the spherical star vehicle—which
                          embodies their central identification with the
                          objective body of light radiating from one’s central
                          being. Our school’s entire system of theurgy is
                          interlocked, contrasting with other systems where
                          rituals may vary widely across several different
                          styles of ritual performance. This will be made clear
                          through the study of the following.{" "}
                        </p>
                        <p>
                          The Theurgic Ritual of the Pentagram, the cornerstone
                          of our transformative ritual praxis, operates on two
                          fundamental principles: banishment and invocation.
                          Banishment, far from a mere act of dismissal, is a
                          profound purification — a cleansing of awareness and
                          the subtle energetic field, preparing both
                          practitioner and space for the influx of higher
                          energies. It creates a sacred void, a holy emptiness,
                          necessary for true reception. Invocation, conversely,
                          is not simply a calling forth, but a deliberate and
                          focused act of drawing down and concentrating divine
                          energies — gods, goddesses, archetypal forces,
                          daemonic intelligences, and all aspects of the Divine:
                          infinite instantiations of our Divine Infinite Being,
                          facets of the Cosmic Reality woven into our very
                          essence.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.upper1199px}`}
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/school_ritual/pentagram_bg_new.webp"
                        alt="Image"
                      />
                      <img
                        className={`${styles.school_ritual_img1} ${styles.lower1199px}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_block11_image_bg_new_1199.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block12-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block12_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          There are elements in our current ritual praxis that
                          were initially established by the Golden Dawn,
                          particularly within our Pentagram ritual framework.
                          The criteria for drawing the pentagrams through
                          invocation and banishing integrate well into our
                          ritual model, serving a similar purpose of purifying
                          the raw elements of fire, water, air, and earth.
                          However, our vision of the Pentagram ritual as a fully
                          interlocked system diverges significantly from that of
                          the Golden Dawn. While the Golden Dawn and, by
                          extension, the Thelemic ritual process adhere to the
                          Kabbalistic Tree of Life and its positions, our
                          approach to ritual praxis presents a distinctly
                          different perspective, which I want to clarify and
                          emphasize. We use elements of their system, but it
                          remains distinct.
                        </p>

                        <p>
                          Through thousands of personal performances of this
                          ritual, in diverse forms over three decades, its
                          visionary purpose has unfolded, allowing me to refine
                          the experience and revealing its profound capacity to
                          connect us with the very source of creation. This
                          extensive practice has also led to significant
                          modifications of the initial ritual framework into a
                          unique set of practices for the School of our Divine
                          Infinite Being.
                        </p>
                        <p>
                          Having worked with nearly every ritual from other
                          Mystery traditions at one time or another, I found
                          myself returning again and again to the Ritual of the
                          Pentagram. In our School, we have chosen to center all
                          other theurgic rites within the framework of this
                          singular, foundational praxis. The Theurgic Ritual of
                          the Pentagram unfailingly opens the way to steady
                          progress in the Great Work. Performed often —
                          especially in close sequence — it reveals ever-deeper
                          layers of esoteric knowledge. This revelation does not
                          come discursively, but directly, through the living
                          recognition of your eternal nature within the
                          boundless expanse of the Cosmos.
                        </p>
                        <p>
                          When performing this ritual, you must build the
                          imaginal forms step by step and hold them together in
                          your mind as one living whole. This means that as each
                          visual is invoked, it remains present in your inner
                          sight while the others are added, creating a layered
                          and complete imaginal field. As you read the
                          instructions below, understand from the start that
                          this is the goal of daily practice. Performing a
                          ritual every day—say, for sixty days—develops the
                          ability to sustain every predicate of the rite in your
                          astral body all at once. Those who have worked at this
                          for weeks know well where this leads: the aspects
                          begin to merge and magnify one another, revealing
                          greater depth. In time, their union will exalt their
                          purpose, and you will hold the entire living form of
                          the ritual within your astral body in unbroken
                          presence.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block12_image_bg_new.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block13-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block13_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <h2>
                          The Ritual of the Pentagram has the following goals:
                        </h2>
                        <p>
                          To align the theurgist with the Absolute — our Divine
                          Infinite Being, the One, the Supreme Ultimate Reality
                          — through the Grand Invocation, uniting the macrocosm
                          and the microcosm so that the personal will stands in
                          perfect harmony with the transcendent order and
                          eternal rhythm of the All.
                        </p>

                        <p>
                          To awaken the theurgist to direct identification with
                          their objective body of light, aligning their
                          consciousness as a solar being, breaking the bonds of
                          spacetime, allowing awareness to realize the immortal,
                          beginningless, and timeless nature of the self{" "}
                          <span>(see Central Doctrine)</span>.
                        </p>

                        <p>
                          To draw into awareness the{" "}
                          <span>“prōtos ochēma psukhēs”</span>—the{" "}
                          <span>"soul's first vehicle"</span>—the spherical star
                          vehicle of Neoplatonic thought. This ochēma, whose
                          name translates to
                          <span> "vehicle" </span> or <span>"conveyance,"</span>{" "}
                          or <span>“chariot,”</span> represents the central
                          spherical boundary which is the point of receptivity
                          and intuitive self-awareness of the surrounding divine
                          whole of experience. It is through this ochēma that
                          the theurgist{" "}
                          <span>"takes the shape of the god"</span> in ritual
                          praxis. <span>“Prōtos”</span> signifies{" "}
                          <span>"first"</span> or <span>"primary,"</span> while{" "}
                          <span>“psukhēs”</span>, derived from{" "}
                          <span>“psukhē”</span>, means <span>"soul"</span> or{" "}
                          <span>"life."</span> Thus, the{" "}
                          <span>“prōtos ochēma psukhēs,”</span> is the manifold
                          through which the theurgist first came into generative
                          existence, representing the infinite, immortal self at
                          the boundary <span>(see Central Doctrine)</span>.{" "}
                        </p>

                        <p>
                          To draw into awareness the imaginal body’s
                          transcendent field of the astral plane — the Anima
                          Mundi, the world into which the gods, goddesses,
                          daemonic intelligences, and archetypal forces enter.
                          To come into direct relationship with them and into
                          transformative agency through their invocation and the
                          vast presence of their living power.
                        </p>

                        <p>
                          To banish and invoke the raw, elemental powers of
                          fire, water, air, and earth — the foundational
                          energies of the four directions and the four theurgic
                          gates — purifying them in the refining fire of the
                          perfecting will of the Creator of the universe, the
                          Dēmiurgós.
                        </p>

                        <p>
                          To offer the theurgist a fully interlocked ritual
                          praxis — a living architecture of invocation — through
                          which any and all divine intelligences may be engaged
                          with both unyielding structure and limitless scope.
                          This method stands as a mirror of the cosmos itself:
                          rigorous in its constraints, yet endlessly expansive
                          in its reach. It provides a universal field of
                          operation from which invocation may be undertaken from
                          any position, whether for general purpose or the
                          highest ceremonial intent. Within this sphere, the
                          planetary gods and the zodiacal forces — both in
                          accord with, and transcending, the bounds of
                          astrological timing — may be approached for theurgic
                          ascent, oracular divination, and the power to manifest
                          futures in perfect consonance with the eternal order.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={styles.school_ritual_img1}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block13_image_bg.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------block14-------------------- */}
            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block14_mainWrp}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          We have structured the Ritual of the Pentagram into
                          five distinct sets of performance. The most
                          fundamental of these, and one that should form the
                          cornerstone of your daily practice, is the Banishing
                          Ritual of the Pentagram. Even if you do not progress
                          to the more complex forms, this daily ritual will
                          significantly enhance your synchronistic, intuitive,
                          and divinatory abilities, while consistently aligning
                          you with Cosmic forces and our Divine Infinite Being.
                          Just as daily prayer is essential for a priest, so too
                          is the Banishing Ritual for the theurgist. Your
                          exploration of the other four versions of the
                          Pentagram Ritual will likely vary, adapting to your
                          individual needs and evolving practice. Through
                          dedicated work, you will find certain times, seasons,
                          and planetary events that resonate with and inform
                          your overall theurgic praxis.
                        </p>

                        <p>
                          The Theurgic Ritual of the Pentagram, in all its forms
                          within our School, always begins with the Grand
                          Invocation — an ascent that opens in the stillness of
                          nonduality and unfolds through a sequence of resonant
                          Divine Names. Each Name summons and shapes the
                          luminous field in which specific eternal intelligences
                          become present. This progression gives rise to a
                          dynamic dualism — theurgist and god-form — called
                          forth and then drawn back into unity, marked by the{" "}
                          <span>“principal centrality”</span> of union within
                          visionary states of consciousness. Here, the theurgist
                          stands at the living axis between the Infinite and its
                          manifest forms. By integrating these states, the
                          ritual establishes a coherent field of alignment in
                          which the theurgist merges with the foundational
                          forces of the Cosmos, bringing into conscious
                          awareness what would otherwise remain latent. In this
                          unity, the sacred space is formed, abstract principle
                          becomes tangible reality, and the practitioner’s
                          divinatory and revelatory capacities are both grounded
                          and magnified.
                        </p>
                        <p>
                          Within the Golden Dawn and Thelemic traditions, there
                          is a sequence of initiations and progressive workings
                          that culminates in the invocation of the Holy Guardian
                          Angel, or Higher Self — which, in our system and in
                          that of Iamblichus, corresponds to the personal daemon
                          or divine double. This approach, while potent, tends
                          to defer the deepest and most transformative union
                          until the very end. Over three decades of dedicated
                          practice, I have found that the reverse order is far
                          more effective: to begin with the deepest union, to
                          place it as the foundation, so that every other
                          working grows from it and carries its living imprint
                          forward.
                        </p>
                        <p>
                          In our School’s method, the Grand Invocation contains
                          within it the full microcosmic ascent and descent
                          through Helios <span>(body of light)</span> and
                          Protogonos{" "}
                          <span>(spherical and infinite divine double)</span>{" "}
                          every single time it is performed. It does not prepare
                          for the union with the divine double as a distant goal
                          — it enacts it, here and now, as the very axis of the
                          rite.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <img
                        className={`${styles.school_ritual_img1} ${styles.upper1199px}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block14_image_bg.webp"
                        alt="Image"
                      />
                      <img
                        className={`${styles.school_ritual_img2} ${styles.lower1199px}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_rituals_block14_image_bg_new.webp"
                        alt="Image"
                      />
                      <img
                        className={`${styles.abs_img1}`}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/banishing_star_bg.webp"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* -----------------------New Block Sanket -------------------- */}

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block15new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={styles.column} ref={theFiveStandardPentaSet}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h2>the five standard pentagram ritual sets</h2>
                    </div>
                  </div>

                  <div className={`${styles.flx_wrpr} ${styles.flx_row}`}>
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={banishingInvocationRitual}
                      >
                        <span>
                          Standard Banishing/Invocation <br />
                          Ritual of the Pentagram
                        </span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The standard Banishing Ritual of the Pentagram is more
                          than 50% of the established connection between the
                          theurgist and the Divine.{" "}
                          <span>
                            This ritual establishes the Cosmos, facilitates
                            connection with the Divine Double
                          </span>
                          , and purifies the forces of nature, aligning them
                          with the theurgist's transcendent nature while also
                          purifying the actions and activities of daily life.
                          Because all other rituals incorporate the Banishing
                          Ritual of the Pentagram, it is a component of every
                          level of practice. In fact, if you are practicing
                          daily or several times a week, the{" "}
                          <span>
                            Banishing Ritual alone will likely comprise 70% to
                            80% of your total ritual practice
                          </span>
                          . Also as an added step performing the invocations of
                          the Pentragram can be integrated as a simple elemental
                          invocation that should be performed at least some of
                          the time, possibly 30% to 50%, and can even be
                          incorporated every time if there is time for it.
                        </p>
                      </div>
                      <div
                        className={
                          styles.ritual_praxis_heading_and_colourful_tableblock_imagecontainer
                        }
                      >
                        <Image
                          className="next_image"
                          src="/image/ritual-praxis-new/school_ritual_block15new_bgimg_new.webp"
                          alt="Section Image"
                          width={1200}
                          height={800}
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.ritual_praxis_heading_and_colourful_table_wrapper
                      }
                    >
                      <div
                        className={`${styles.ritual_praxis_heading_and_colourful_table} ${styles.ritual_praxis_heading_and_colourful_table_margin_left}`}
                      >
                        <div
                          className={
                            styles.ritual_praxis_heading_and_colourful_table_headingwrapper
                          }
                        >
                          <h3>The Components are</h3>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              01
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              The Grand Invocation
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              02
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Casting of the Pentagrams
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} ${styles.ritual_praxis_heading_and_colourful_table_card_subpointmultiple}`}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking (if performing)
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              03
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Calling of the Guardians
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              04
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Closing of the Ritual
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block16new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.flx_wrpr} ${styles.flx_row} ${styles.flx_row_reverse}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={divineInfiniteInvocationRitual}
                      >
                        <span>
                          Divine Infinite Being Invocation Ritual <br />
                          of the Pentagram
                        </span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The{" "}
                          <span>
                            Divine Infinite Being Invocation Ritual of the
                            Pentagram
                          </span>{" "}
                          is the primary invocation within our School’s praxis —
                          a rite that both amplifies and draws toward unified
                          simplicity the full predicates of the Grand
                          Invocation, serving as a powerful final alignment
                          within the praxis structure. It functions as a
                          focusing lens, concentrating the diverse elements of
                          the rite into a single, resonant axis of divine
                          presence, while at the same time magnifying their
                          potency. In this way, the ritual is not only an
                          invocation in itself but also a clarifier — distilling
                          the entire structure of the Grand Invocation into its
                          essential symmetry and transmitting that resonance
                          through every part of the theurgist’s being. Its
                          pronouncement, found at the opening of our Central
                          Doctrine and reproduced below, marks the threshold,
                          with the theurgist standing at the still point between
                          Macrocosm and Microcosm.
                        </p>
                        <p>
                          An important feature of this level of the Theurgic
                          Ritual of the Pentagram is its extraordinary
                          adaptability. The pronouncement for our Divine
                          Infinite Being may be replaced with the specific
                          invocation and pronouncement of any divine
                          intelligence — god, goddess, or higher daemonic
                          presence — drawn from any sacred tradition. Whether it
                          is an Egyptian netjer, a Norse god, a Hindu deity, an
                          ancient Sumerian power, or any other instantiation
                          from the infinite pantheon of the ages, the same
                          structural potency is preserved. I myself often
                          utilize this space to invoke Christ as a solar deity,
                          or Hadit and Nuit from the Thelemic current. The
                          chosen intelligence is enthroned in the same pivotal
                          space, allowing the full ritual arc to unfold around
                          its agency.
                        </p>
                        <p>
                          While this adaptability is universal, working
                          specifically with the planetary gods and zodiacal
                          powers of the solar zodiac requires progressing into
                          the three rituals that follow this one, as they
                          maintain the larger structure of the work.
                        </p>
                        <p>
                          It is recommended that, in the absence of another
                          specific working, the standard Divine Infinite Being
                          Invocation be performed at least once a week. When
                          possible, dedicate several consecutive days to it,
                          allowing its living imprint to take deeper root with
                          each repetition.
                        </p>
                      </div>
                      <div
                        className={
                          styles.ritual_praxis_heading_and_colourful_tableblock_imagecontainer
                        }
                      >
                        <Image
                          className="next_image"
                          src="/image/ritual-praxis-new/school_ritual_block16new_bgimg_new.webp"
                          alt="Section Image"
                          width={1200}
                          height={800}
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.ritual_praxis_heading_and_colourful_table_wrapper
                      }
                    >
                      <div
                        className={`${styles.ritual_praxis_heading_and_colourful_table} ${styles.ritual_praxis_heading_and_colourful_table_margin_right}`}
                      >
                        <div
                          className={
                            styles.ritual_praxis_heading_and_colourful_table_headingwrapper
                          }
                        >
                          <h3>The Components are</h3>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              01
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              The Grand Invocation
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              02
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Casting of the Pentagrams
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} ${styles.ritual_praxis_heading_and_colourful_table_card_subpointmultiple}`}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              03
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Calling of the Guardians
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              04
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Central Pronouncement of our Divine Infinite Being
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_orangebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              05
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Closing of the Ritual
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block17new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={`${styles.flx_wrpr} ${styles.flx_row}`}>
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={planetaryInvocationRitual}
                      >
                        <span>
                          Planetary Invocation Ritual of the
                          <br /> Pentagram
                        </span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The{" "}
                          <span>
                            Planetary Invocation Ritual of the Pentagram
                          </span>{" "}
                          is a central model and a foundational gateway for
                          advanced astrological theurgy within our School. Our
                          praxis emphasizes the invocation, harmonization, and
                          conscious alignment of all ten Planetary Gods of
                          astrology — each a vast, transconscious divine
                          intelligence — within the theurgist’s active
                          awareness. This process draws their otherwise
                          unconscious operation into the full light of
                          consciousness, where they can be ritually purified,
                          amplified, and integrated into the theurgist’s work
                          with karmic patterns, providential timing, and the
                          laws of Dharma.
                        </p>
                        <p>

                          While this rite may be performed without prior
                          astrological study, in our Mystery School it is most
                          often practiced in direct relationship to the natal
                          chart and the living movements of Divine Timing in
                          astrology. In this way, the invocation of each
                          Planetary God serves a dual purpose. First, it
                          forges an active relationship with the god’s agency,
                          freeing the theurgist from being passively bound to
                          its unconscious influences. Second, it enables the
                          practitioner to engage both their natal placements
                          and current transits from a place of co-creative
                          alignment, rather than mere submission to fate.

                        </p>
                        <p>
                          When the theurgist has ritually invoked, purified, and
                          consciously aligned with the agencies of Saturn and
                          Mars, for example, a challenging aspect between these
                          powers in their transits — such as an opposition or
                          square — is no longer received as an inevitable
                          burden. Instead, it is perceived as a moment of
                          heightened potential, a precise configuration for
                          transformation and manifestation, in which those same
                          intensities are deliberately harnessed to shift the
                          personal field of reality toward chosen outcomes.
                        </p>
                        <p>
                          This approach extends beyond simple mitigation or
                          empowerment. By working ritually with the Planetary
                          Gods as they are enthroned in one’s nativity, the
                          theurgist refines their ability to engage each
                          planetary agency in both its exalted and challenging
                          expressions, developing a total spectrum relationship
                          with each divine power. When this work is further
                          integrated with the larger astrological theurgic
                          structure — invoking planetary and zodiacal forces
                          both within and outside of divine timing windows — it
                          becomes a comprehensive field for divination,
                          manifestation, and transcendent contact.
                        </p>
                        <p>
                          While the benefits are countless — heightened
                          intuitive revelation, clearer oracular insight,
                          accelerated manifestation — the primary aim remains
                          the same: to engage the planetary agencies as living,
                          divine beings, in their full interplay within the
                          microcosm of the self and the macrocosm of the
                          heavens, through direct and disciplined experience.
                        </p>
                      </div>
                      <div
                        className={
                          styles.ritual_praxis_heading_and_colourful_tableblock_imagecontainer
                        }
                      >
                        <Image
                          className="next_image"
                          src="/image/ritual-praxis-new/school_ritual_block17new_bgimg.webp"
                          alt="Section Image"
                          width={1200}
                          height={800}
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.ritual_praxis_heading_and_colourful_table_wrapper
                      }
                    >
                      <div
                        className={`${styles.ritual_praxis_heading_and_colourful_table} ${styles.ritual_praxis_heading_and_colourful_table_margin_left}`}
                      >
                        <div
                          className={
                            styles.ritual_praxis_heading_and_colourful_table_headingwrapper
                          }
                        >
                          <h3>The Components are</h3>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              01
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              The Grand Invocation
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              02
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Casting of the Pentagrams
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              03
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Calling of the Guardians
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              04
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Invocation of Hermes/Apollo
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_orangebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              05
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Opening of the Gates
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} ${styles.ritual_praxis_heading_and_colourful_table_card_subpointmultiple}`}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking (if performing)
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_yellowbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              06
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Planetary Invocation and Pronouncement
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              07
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Closing of the Ritual
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block18new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.flx_wrpr} ${styles.flx_row} ${styles.flx_row_reverse}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={zodiacalInvocationRitual}
                      >
                        <span>Zodiacal Invocation Ritual of the Pentagram</span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The <span>Zodiacal Invocation Ritual of the Pentagram</span> is exactly what its name suggests: the direct invocation of the twelve living intelligences of the Zodiac. While these rites can be performed in any sequence and at any time, their deepest potency emerges when each sign is opened and invoked on its corresponding solar ingress — the day the Sun enters that sign in the astrological year. In this alignment, the invocation resonates with the full presence of that sign’s embodiment in the heavens, magnifying its agency within the theurgist’s field.
                        </p>
                        <p>
                          Unlike the Planetary Gods — dynamic, moving spheres whose cyclical dance through spacetime generates shifting aspects and transits — the Zodiacal signatures are the great celestial temples, the <span>“solar houses”</span> through which the Sun’s light passes in its yearly journey. To enter their sphere is to inhabit a vast, archetypal habitation of consciousness, much like one’s birth within a specific time, place, and sky binds the soul to certain qualities from the moment of incarnation.
                        </p>
                        <p>
                          These signs mark the eternal cycle of qualia — the living, felt tones of being — that color the experience of all creatures on Earth. Each sign holds its own complete nature, which is imprinted upon the world as the Sun moves from the waning influence of one solar embodiment, through its full radiance at the heart of the sign, and onward into the ascending tide of the next. The Zodiacal Invocation Ritual allows the theurgist not only to witness these transitions, but to step within them as a co-creative participant, calling forth the solar presence of the sign to enter both the microcosm of the self and the macrocosm of the ritual space.
                        </p>
                      </div>
                      <div
                        className={
                          styles.ritual_praxis_heading_and_colourful_tableblock_imagecontainer
                        }
                      >
                        <Image
                          className="next_image"
                          src="/image/ritual-praxis-new/school_ritual_block18new_bgimg.webp"
                          alt="Section Image"
                          width={1200}
                          height={800}
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.ritual_praxis_heading_and_colourful_table_wrapper
                      }
                    >
                      <div
                        className={`${styles.ritual_praxis_heading_and_colourful_table} ${styles.ritual_praxis_heading_and_colourful_table_margin_right}`}
                      >
                        <div
                          className={
                            styles.ritual_praxis_heading_and_colourful_table_headingwrapper
                          }
                        >
                          <h3>The Components are</h3>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              01
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              The Grand Invocation
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              02
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Casting of the Pentagrams
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              03
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Calling of the Guardians
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              04
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Invocation of Hermes/Apollo
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_orangebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              05
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Opening of the Gates
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_yellowbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              06
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Zodiacal Invocation and Pronouncement
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              07
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Closing of the Ritual
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block19new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={`${styles.flx_wrpr} ${styles.flx_row} `}>
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={celestialInvocationRitual}
                      >
                        <span>
                          Celestial Invocation Ritual of the Pentagram
                        </span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          The <span>Celestial Invocation Pentagram Ritual</span> possesses the broadest range of applications among all our ritual practices, serving both as a foundation for specialized personal work and as the core structure of our 15-month inner mystery school program. This ritual integrates planetary and zodiacal invocations, allowing for the focused application of specific planetary forces within a chosen zodiacal sign and, crucially, within the native’s own chart: the planets as placed at birth and the signs they inhabit <span>(optionally keyed through the Ascendant and chart ruler)</span>. In practice, it draws the otherwise unconscious operation of these agencies into full awareness, where they can be purified, amplified, and harmonized with the theurgist’s active work, karmic vectors, and Dharma.
                        </p>

                        <p>
                          Beyond the natal map, the rite is expressly designed
                          to operate in <span>Divine Timing</span>. It can be
                          keyed to transits that perfect to natal planets or
                          angles, to solar ingresses and decan windows, to
                          planetary days and hours, and to chosen electional
                          moments—thereby lensing the invoked force through the
                          most potent temporal aperture available. This makes
                          the Celestial Invocation Ritual an exceptionally
                          flexible chassis for working{" "}
                          <span>across all dimensions at once</span>: sign +
                          planet, natal + transit, angle + aspect, timing +
                          intention—so the future can be{" "}
                          <span>consciously manifested in alignment</span>{" "}
                          rather than passively received as fate.
                        </p>
                        <p>
                          Drawing upon{" "}
                          <span>Mathers’ pentagram arrangement</span> within the
                          Tarot’s small cards, our 15-month program leverages
                          this framework for invoking{" "}
                          <span>daemonic spirits</span> and their corresponding
                          designations within the{" "}
                          <span>astrological decan system</span>. Each zodiacal
                          sign is divided into three ten-day periods, each
                          associated with a specific planetary intelligence and
                          daemonic spirit; working these decans in sequence
                          purifies and aligns the theurgist with the{" "}
                          <span>generative forces of existence</span>. A
                          comprehensive library of these symbolic associations
                          is available on our website under{" "}
                          <span>ROTA: The Wheel</span>.
                        </p>

                        <p>
                          The{" "}
                          <span>
                            Celestial Pentagram (the operational form of this
                            rite)
                          </span>{" "}
                          is performed a minimum of <span>36 times</span> within
                          the program’s required period, corresponding to the{" "}
                          <span>36 decans</span> on the astrological wheel. Upon
                          mastering the ritual and completing the full year of
                          dedicated practice, the theurgist can then adapt its
                          framework to create personalized operations for a wide
                          variety of purposes—<span>manifestation work</span>{" "}
                          tied to Divine Timing,{" "}
                          <span>
                            divinatory and intuitive practices (including Horary
                            Astrology)
                          </span>
                          , remediation keyed to natal <span>angles</span> and
                          transits, and countless other applications. In every
                          case, the ritual offers a single, interlocked praxis
                          capable of structurally engaging <span>any</span>{" "}
                          combination of signs, planets, angles, and timing, and
                          of doing so with both rigorous constraint and
                          expansive scope.
                        </p>
                      </div>
                      <div
                        className={
                          styles.ritual_praxis_heading_and_colourful_tableblock_imagecontainer
                        }
                      >
                        <Image
                          className="next_image"
                          src="/image/ritual-praxis-new/school_ritual_block19new_bgimg_new.webp"
                          alt="Section Image"
                          width={1200}
                          height={800}
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.ritual_praxis_heading_and_colourful_table_wrapper
                      }
                    >
                      <div
                        className={`${styles.ritual_praxis_heading_and_colourful_table} ${styles.ritual_praxis_heading_and_colourful_table_margin_left}`}
                      >
                        <div
                          className={
                            styles.ritual_praxis_heading_and_colourful_table_headingwrapper
                          }
                        >
                          <h3>The Components are</h3>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              01
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              The Grand Invocation
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              02
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Casting of the Pentagrams
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Banishing
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              03
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Calling of the Guardians
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              04
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Invocation of Hermes/Apollo
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_orangebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              05
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Invocation and Pronouncement of Decan Daemonic
                              Intelligence if Performing
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_yellowbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              06
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Opening of the Gates
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_greenbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              07
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Planetary Invocation and Pronouncement
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_bluebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              08
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Opening of the Gates
                            </h3>
                          </div>
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint_wrap} `}
                          >
                            <p
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_subpoint}`}
                            >
                              Invoking
                            </p>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_violetbg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              09
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Zodiacal Invocation and Pronouncement
                            </h3>
                          </div>
                        </div>
                        <div
                          className={`${styles.ritual_praxis_heading_and_colourful_table_cardwrap} ${styles.ritual_praxis_heading_and_colourful_purplebg}`}
                        >
                          <div
                            className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_wrap}`}
                          >
                            <span
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_number}`}
                            >
                              10
                            </span>
                            <h3
                              className={`${styles.ritual_praxis_heading_and_colourful_table_card_heading_text}`}
                            >
                              Closing of the Ritual
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block20new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={styles.column} ref={grandTheurgicInvocation}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h2>GRAND THEURGIC INVOCATION</h2>
                    </div>
                  </div>

                  <div
                    className={`${styles.flx_wrpr} ${styles.flx_row} ${styles.flx_row_reverse}`}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          <span className="common_medium_font">
                            The Grand Theurgic Invocation
                          </span>{" "}
                          marks the sacred beginning of our Theurgical Ritual
                          Praxis. It is the foundational rite by which the
                          ritual space is consecrated and the practitioner is
                          aligned with both the greater order of the Cosmos and
                          the divine essence within. Divided into two parts,
                          this invocation first engaged the embodiment of the
                          Macrocosm—activating the ritual space through ancient
                          Names of Power and universal currents. It then turns
                          inward, drawing the energy down into the Microcosm—the
                          self—through invocation of personal divine archetypes
                          and forces of inner awakening. Nothing proceeds until
                          this grand harmonization is complete, anchoring the
                          theurgist as a vessel between Heaven and Earth.
                        </p>
                      </div>
                      <h4 className={styles.white_small_heading}>
                        The Grand Invocation
                      </h4>
                      <div className={styles.bluebg_greenpoints_section}>
                        <div className={styles.bluebg_greenpoints_inner}>
                          <h5
                            className={styles.bluebg_greenpoints_inside_heading}
                          >
                            Macrocosmic Alignment (Space Activation)
                          </h5>
                          <div className={styles.bluebg_greenpoints_wrapper}>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>'Ehye 'ăšer 'Ehye</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>YHVH</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>Elohim</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>YHVH Elohim</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>Kali-Krishna</span>
                            </p>
                          </div>
                        </div>
                        <div className={styles.bluebg_greenpoints_inner}>
                          <h5
                            className={styles.bluebg_greenpoints_inside_heading}
                          >
                            Microcosmic Alignment (Self Actualization)
                          </h5>
                          <div className={styles.bluebg_greenpoints_wrapper}>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>Hecate</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>Helios</span>
                            </p>
                            <p className={styles.bluebg_greenpoint}>
                              Invocation of <span>Protogonos</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <Image
                        className="next_image"
                        src="/image/ritual-praxis-new/school_ritual_block20new_bgimg_new.webp"
                        alt="Section Image"
                        width={1200}
                        height={800}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block21new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={`${styles.flx_wrpr} ${styles.flx_row} `}>
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <h2
                        className={styles.ritual_praxis_blocktop_white_heading}
                        ref={introGrandTheurgicInvocation}
                      >
                        <span>Introduction To The Grand Invocation</span>{" "}
                      </h2>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <p>
                          <span className="common_bold_font">
                            The Grand Invocation is not merely a sequence of
                            distinct deities, but a deepening revelation of a
                            single divine continuum—unfolding within the sacred
                            “shape” of the eternally unified Divine Parent
                            (Macrocosm) and the Child within the Egg (Microcosm)
                          </span>
                          . Each Name invoked is not separate from the one
                          before it, but rather nested within it—an emanational
                          cascade of divine self-disclosure. At each succession,
                          the God is not just summoned as an external force, but
                          invited to incarnate into the conscious experience of
                          the theurgist, manifesting through the synergistic
                          power of sacred sound, concentrated mind, divine love
                          and sympathy.
                        </p>
                        <p>
                          Each vast agency arrives not from{" "}
                          <span>“elsewhere,”</span> but from both within and
                          beyond, shaping the theurgist's field of being through
                          the act of ritual. This is not a mere descent, but a
                          co-presence: a layered unveiling wherein the highest
                          principle, once invoked, does not recede but remains
                          present—silently sustaining each successive form. From
                          the non-dual to the fully embodied, the ritual becomes
                          the living bridge, where the divine presence deepens,
                          intensifies, and incarnates through each sacred Name.
                        </p>
                        <p>
                          This layered structure can only be{" "}
                          <span>“entered,”</span> not explained, as it operates
                          beyond the grasp of ordinary cognition. It requires
                          the theurgist to release the reflexes of common sense,
                          offering their persona as a sacrament and yielding to
                          the counter-intuitive logic of higher Worlds.
                        </p>
                        <p>
                          Here is just a general comment. Everywhere it gives a
                          general statement of{" "}
                          <span>“the Ritual of the Pentagram”</span> you need to
                          change it to{" "}
                          <span>“the Theurgic Ritual of the Pentagram”</span>{" "}
                          but be careful as there are other names such as <span>"The
                            Celestial Ritual of the Pentagram”</span> that should not be
                          changed.
                        </p>
                        <p>
                          Thus, theurgic ritual cannot be judged by empirical or
                          discursive criteria. Its logic is{" "}
                          <span className="common_bold_font">hierophanic</span>
                          —it reveals by transforming the one who perceives.
                          Each invocation both summons what appears as an
                          external being, which opens a deeper register of
                          reality—revealing what was latent by drawing it into
                          visibility through an involutionary process. The outer
                          manifestation arises from an inward identification
                          with the divine, not as something separate, but as an
                          integrated whole: simultaneously within and without,
                          without division. To speak these names with attuned
                          consciousness is to let the divine Self/God Archetype
                          to{" "}
                          <span className="common_bold_font">
                            self-unfold
                          </span>{" "}
                          through the body and being of the theurgist.
                        </p>
                        <p>
                          <span className="common_bold_font">
                            We will explore each stage of the Grand Invocation
                            in detail—alongside the Resonate Divine Names—but
                            first, let us offer a step-by-step summary of the
                            process as a whole.
                          </span>
                        </p>
                        <h3 className={styles.green_small_heading}>
                          The Macrocosmic Alignment
                        </h3>
                        <p>
                          In the Macrocosmic Alignment, the theurgist ascends
                          through strata of divine order even as the embodied
                          deification of the infinite whole descends—a paradox
                          that defies linear logic and unfolds only through
                          counter-intuitive recognition. This descent is not
                          separate from the <span>'Self'</span> of the
                          theurgist, but reveals the Self as already enfolded
                          within the divine. The god or goddess does not merely
                          appear; they embody the theurgist as the theurgist
                          simultaneously rises into their eternal order. The
                          result is not fusion in the sense of merging two
                          beings, but the unveiling of their already-present
                          wholeness through suprarational embodiment.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <Image
                        className="next_image"
                        src="/image/ritual-praxis-new/school_ritual_block21new_bgimg.webp"
                        alt="Section Image"
                        width={1200}
                        height={800}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block22new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.flx_wrpr} ${styles.flx_row} ${styles.flx_row_reverse} `}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <h3 className={styles.green_small_heading}>
                          Ehyeh – The Non-Dual Foundation
                        </h3>
                        <p>
                          The invocation of Ehyeh is the opening of the ritual
                          not just in time, but in{" "}
                          <span className="common_bold_font">
                            ontological precedence
                          </span>
                          . It is not the first in a series; it is{" "}
                          <span className="common_bold_font">
                            the unconditioned ground
                          </span>{" "}
                          in which the others appear. It is the ever-present
                          non-dual awareness{" "}
                          <span className="common_medium_font">
                            (aham in Śaiva terms)
                          </span>
                          , the pulse of{" "}
                          <span className="common_bold_font">śāmbhava</span>,
                          where all potential rests undifferentiated.
                        </p>
                        <p>
                          To say Ehyeh{" "}
                          <span className="common_medium_font">("I Am")</span>{" "}
                          is to become that unstructured self-awareness. From
                          the tantric perspective, it is the{" "}
                          <span className="common_bold_font">bindu</span>—the
                          point before any unfolding—but already saturated with
                          the power to manifest. Every divine name to follow
                          emerges as a{" "}
                          <span className="common_bold_font">
                            differentiated expression
                          </span>{" "}
                          of this undivided state.
                        </p>
                        <p>
                          Crucially, Ehyeh does not recede. It remains the{" "}
                          <span className="common_bold_font">substrate</span>—an
                          ever-present horizon from which all subsequent
                          intelligences derive their being and through which
                          they maintain their coherence.
                        </p>
                        <h3 className={styles.green_small_heading}>
                          Counter-Intuition as the Theurgic Threshold
                        </h3>
                        <p>
                          Once this non-dual awareness is opened, the ritual
                          requires a surrender of all inherited interpretive
                          frameworks. From this point forward, nothing{" "}
                          <span className="common_medium_font">
                            "makes sense"
                          </span>{" "}
                          from the perspective of the empirical ego. The gods
                          that arrive are not mental constructs, nor are they
                          projections. They are{" "}
                          <span className="common_bold_font">
                            divine actualities
                          </span>
                          —yet their mode of appearing feels impossible to the
                          rational self. This is{" "}
                          <span className="common_bold_font">
                            the mark of authenticity
                          </span>
                          .
                        </p>
                        <p>
                          As Ginsburgh writes, what is{" "}
                          <span className="common_bold_font">
                            “counter-intuitive”
                          </span>{" "}
                          at one level is common sense at the next. Thus, as
                          each divine name is invoked, the theurgist is being
                          moved—sometimes violently—into a new ontic World. The
                          vision of the god or goddess is the proof that
                          counter-intuition has functioned: the seal has opened,
                          and a new form of divine reason is flowing through the
                          bodymind.
                        </p>

                        <p>
                          From here, each divine name becomes a{" "}
                          <span className="common_bold_font">vessel</span> for
                          the previous. They do not stand apart like pillars,
                          but{" "}
                          <span className="common_bold_font">
                            nest within each other
                          </span>
                          , each one more embodied, more differentiated, yet
                          still held in the echo of Ehyeh. This is the ritual’s
                          inner recursion: each god appears within the first
                          god, never apart from it.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <Image
                        className="next_image"
                        src="/image/ritual-praxis-new/school_ritual_block22new_bgimg.webp"
                        alt="Section Image"
                        width={1200}
                        height={800}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block23new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div className={`${styles.flx_wrpr} ${styles.flx_row} `}>
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <h3 className={styles.green_small_heading}>
                          Embodied Descent as Nested Revelation
                        </h3>
                        <div className={styles.ritual_praxis_yellowboxbullet}>
                          <p>
                            <i>YHVH</i> emerges as the divine axis of
                            being—masculine will, centripetal form. But it{" "}
                            <span>speaks from within Ehyeh</span>, as the first
                            stirrings of direction within pure being.
                          </p>
                          <p>
                            Elohim emerges as the encircling womb—the reflective
                            aspect, cosmic feminine. But she too arises within{" "}
                            <i>YHVH</i>, who himself is already held in the
                            openness of Ehyeh.
                          </p>
                          <p>
                            <i>YHVH Elohim</i> is not a new god, but the
                            resonant fusion—a harmonic reinforcement that
                            renders the polarity dynamically stable. The unity
                            now <span>shines through the two</span>.
                          </p>
                          <p>
                            <i>Kali-Krishna</i> is the intimacy of that union
                            embodied—the felt god, the tasted goddess. The monad
                            becomes sensuous. But again: they do not stand
                            apart. They are <span>the relational form</span> of
                            all the previous names made experiential.
                          </p>
                        </div>
                        <h3 className={styles.green_small_heading}>
                          Microcosmic Alignment
                        </h3>
                        <p className="common_italic_text">
                          The Embryonic God, Born of the Infinite
                        </p>
                        <p>
                          With the intimacy of Kali-Krishna, the macrocosmic
                          chain of being has been sounded into flesh. The whole
                          descent of divine intelligences has unfolded through
                          sound and presence. Yet this is not the end—it is the
                          turning point. Now begins the{" "}
                          <span>Microcosmic Alignment,</span> the spiral of
                          return hidden within the descent.
                        </p>
                        <p>
                          If the macrocosmic phase reveals the gods as they are,
                          this phase reveals them <span>as you are</span>. The
                          theurgist ceases to address the heavens and instead
                          becomes their <span>mirrored echo</span>—not separate,
                          not derivative, but a{" "}
                          <span>recursive micro-form</span> of the divine whole.
                          This is not metaphor. It is the actualization of the
                          ochema, the soul-body as divine infrastructure.
                        </p>
                        <p>
                          In this turning,{" "}
                          <span>counter-intuition inverts itself</span>: what
                          once seemed <span>“other”</span> becomes most
                          intimate, while what once seemed <span>“you”</span>{" "}
                          dissolves into a larger intelligence. You are no
                          longer invoking the gods. You are{" "}
                          <span>inhabited by them</span>.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <Image
                        className="next_image"
                        src="/image/ritual-praxis-new/school_ritual_block23new_bgimg.webp"
                        alt="Section Image"
                        width={1200}
                        height={800}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            <LazySection>
              <div
                className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_block24new_mainWrp} ${styles.ritual_praxis_heading_and_colourful_tableblock_wrapper}`}
              >
                <div className={styles.common_width}>
                  <div
                    className={`${styles.flx_wrpr} ${styles.flx_row} ${styles.flx_row_reverse} `}
                  >
                    <div className={styles.school_ritual_txt_box_wrpr}>
                      <div className={styles.school_ritual_txt_box_innr}>
                        <h3 className={styles.green_small_heading}>
                          Hecate – The Womb of Inner Form
                        </h3>
                        <p>
                          Hecate now appears not as a summoning, but as a
                          remembering. She is the{" "}
                          <span className="common_bold_font">lunar matrix</span>
                          , the
                          <span> <i>chthonic Anima Mundi</i> </span> that has been gestating
                          every god already called. She reveals that the divine
                          did not come from above—but from beneath, from within,
                          from before.
                        </p>
                        <p>
                          She is the silent matrix of your visionary capacity,
                          the subconscious infrastructure of all daemonic
                          contact. In the Śaiva Tantric sense, Hecate is{" "}
                          <span className="common_medium_font">
                            kālī as night
                          </span>
                          , as the vibratory substratum in which the divine
                          chooses its faces. Theurgically, she is the{" "}
                          <span className="common_medium_font">
                            threshold guardian
                          </span>
                          : you may enter the light only through her. She is not
                          obstacle—she is <span> <i>precondition</i> </span>. Every name, every
                          image, every god has passed through her mirror.
                        </p>
                        <h3 className={styles.green_small_heading}>
                          Helios – The Radiant Core Within
                        </h3>
                        <p>
                          When Helios arises, it is no longer from the sky. It
                          is{" "}
                          <span className="common_bold_font">
                            from the chest
                          </span>
                          , the brow, the breath. He is not seen—he is known, as{" "}
                          <span className="common_bold_font">
                            bodily luminosity
                          </span>
                          , the self-radiance of consciousness unveiled.
                        </p>

                        <p>
                          This is the theurgist’s{" "}
                          <span className="common_bold_font">solar being</span>,
                          what Tantrāloka would call{" "}
                          <span className="common_bold_font">prakāśa</span>—the
                          light of awareness made visible. Not symbolic light,
                          but ontic illumination{" "}
                          <span className="common_medium_font">
                            (see Central Doctrine on the body of light)
                          </span>
                          . Helios does not{" "}
                          <span className="common_medium_font">“shine on”</span>{" "}
                          the gods; he shines{" "}
                          <span className="common_bold_font">through</span>{" "}
                          them, and now through you, self identified as the
                          timeless, massless radiant being.
                        </p>
                        <p>
                          Here, vision becomes self-generating. The gods no
                          longer appear as emissaries. They are{" "}
                          <span className="common_bold_font">
                            the flowering of your own solar ground
                          </span>
                          . The ritual shifts from invocation to{" "}
                          <span className="common_bold_font">emanation</span>.
                        </p>
                        <h3 className={styles.green_small_heading}>
                          Protogonos – The Infinite Within the Finite
                        </h3>
                        <p>
                          And finally: <span>Protogonos</span>, the First-Born,
                          the cosmic Androgyne. This is the recognition of{" "}
                          <span>the infinite double</span>—what Iamblichus calls
                          the divine vehicle{" "}
                          <span className="common_italic_text">(ochema)</span>{" "}
                          fully realized. It is the theurgist’s eternal
                          image—the self in its pre-worldly, post-temporal form.
                        </p>
                        <p>
                          But Protogonos is not a culmination. He is the
                          co-presence of all things. He contains Ehyeh and every
                          god that followed. He is not beyond them. He is{" "}
                          <span>their enfolding</span> in the theurgist’s own
                          realized being.
                        </p>
                        <p>
                          This is <span>svātantrya</span> in the tantric
                          register—<span>sovereign freedom</span>, the capacity
                          of the divine to appear in all forms, including this
                          one: your voice, your spine, your breath.
                        </p>
                      </div>
                    </div>

                    <div className={styles.school_ritual_img_box_wrpr}>
                      <Image
                        className="next_image"
                        src="/image/ritual-praxis-new/school_ritual_block24new_bgimg.webp"
                        alt="Section Image"
                        width={1200}
                        height={800}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
          </div>
          {/* ------------------------------------psd3 section-------------------- */}
          <Block2
            standardBanishingRef={standardBanishingRef}
            standardDivineInfiniteRef={standardDivineInfiniteRef}
            planetaryInvocationRef={planetaryInvocationRef}
            zodiacalInvocationRef={zodiacalInvocationRef}
            theMacrocosmicRef={theMacrocosmicRef}
            celestialInvocationRitual={celestialInvocationRitual}
          />
          <SchoolRitualBlockThree
            theMicrocosmicRef={theMicrocosmicRef}
            aligningTheElementsRef={aligningTheElementsRef}
            invocationOfTheRef={invocationOfTheRef}
            finalPronouncementRef={finalPronouncementRef}
            hermesApolloRef={hermesApolloRef}
            invocationOfDivineInfiniteBeing={invocationOfDivineInfiniteBeing}
          />
          <SchoolRitualBlockFour
            openingOfTheGatesRef={openingOfTheGatesRef}
            planetaryIntelligenciesRef={planetaryIntelligenciesRef}
            theSunArchetypeRef={theSunArchetypeRef}
            theMoonArchetypeRef={theMoonArchetypeRef}
            // natalIncarnationRef={natalIncarnationRef}
            planetaryResonanceRef={planetaryResonanceRef}
            planetaryDecagramRef={planetaryDecagramRef}
          />

          <BlockFive
            theMercuryArchetype={theMercuryArchetype}
            theVenusArchetype={theVenusArchetype}
            theMarsArchetype={theMarsArchetype}
            theJupiterArchetype={theJupiterArchetype}
            theSaturnArchetype={theSaturnArchetype}
          />

          <SchoolRitualBlockSix
            theUranusArchetypeRef={theUranusArchetypeRef}
            theNeptuneArchetypeRef={theNeptuneArchetypeRef}
            thePlutoArchetypeRef={thePlutoArchetypeRef}
            alignmentWithTheZodiacRef={alignmentWithTheZodiacRef}
            ariesInvocationRef={ariesInvocationRef}
            taurasInvocationRef={taurasInvocationRef}
            geminiInvocationRef={geminiInvocationRef}
            cancerInvocationRef={cancerInvocationRef}
          />
          <BlockSeven
            leoInvocationRef={leoInvocationRef}
            virgoInvocationRef={virgoInvocationRef}
            libraInvocationRef={libraInvocationRef}
            scorpioInvocationRef={scorpioInvocationRef}
            sagittariusInvocationRef={sagittariusInvocationRef}
            capricornInvocationRef={capricornInvocationRef}
            aquarisInvocationRef={aquarisInvocationRef}
            piscesInvocationRef={piscesInvocationRef}
            natalIncarnationRef={natalIncarnationRef}
          />
        </div>

        {/* </div> */}
      {/* </div> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description"
            component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
}

export default Index;
